import { render, staticRenderFns } from "./JSONataEditor.vue?vue&type=template&id=dc3b6d24&scoped=true&"
import script from "./JSONataEditor.vue?vue&type=script&lang=js&"
export * from "./JSONataEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc3b6d24",
  null
  
)

export default component.exports